import { ComboBox,DropDownList,DropDownListFilterChangeEvent, DropDownListChangeEvent, ListItemProps, MultiSelect, MultiSelectChangeEvent, MultiSelectFilterChangeEvent, ComboBoxChangeEvent, ComboBoxFilterChangeEvent } from '@progress/kendo-react-dropdowns';
import { CompositeFilterDescriptor, filterBy, FilterDescriptor, FilterOperator, isCompositeFilterDescriptor } from '@progress/kendo-data-query';
import { getCustomerList, getStatusList,getSavedQueries, getRepList,getSectionList,getTeamList,getSizeList, getColTypeList, getPubList, getSiteList, getPickupList, getPickupToList } from '../services/apiService';
import React, { useState, useEffect, ChangeEvent } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faCircle} from '@fortawesome/free-solid-svg-icons';
import { StatusDataItem, salesRep, FileType, PubListEntry, rollUpGroup } from '../services/interfaces';
import { useContext } from 'react';
import { PageContext } from './PageContext';
import { UserContext } from './UserContext';
import { FieldWrapper } from '@progress/kendo-react-form';
import { Input,Checkbox, CheckboxChangeEvent } from '@progress/kendo-react-inputs';
import { makeShortDate } from './DateTimeHelpers';
import { Grid,GridColumn } from '@progress/kendo-react-grid';
import { SiteEntry,ColTypeEntry,PickupSelection } from '../services/interfaces';
import { SubmissionContext } from './SubmissionFormContext';
import { getAllRollUpGroups, getModColTypes } from '../services/apiAdminService';
import { SubmissionForm } from './SubmissionForm';



interface CustomerListProps {
    setReturnAction: (customer: any) => void;
    value:{customer:string,fileSize2:string,file1:string}|undefined;
    site:SiteEntry|string;
    valid:boolean;
    allowNew:boolean;
}

export function CustomerList({
    setReturnAction,value,site,valid, allowNew
}: CustomerListProps){
    //Component for a customer drop down list
    const [customers, setCustomers] = useState<any[]>([]);
    const [selCustomer,setSelCustomer]=useState<{customer:string,fileSize2:string, file1:string} | undefined>(undefined);
    const filterData = async (filter: FilterDescriptor | CompositeFilterDescriptor) => {
        const data = await getCustomerList();
        if (site !== "" && (site as SiteEntry)?.code !== undefined){
            const siteCode = (site as SiteEntry).code;
            console.log("Filter by site: " + siteCode);
            const siteFilter: FilterDescriptor = {
                field: "file1",
                value: siteCode,
                operator: "equals",
                ignoreCase:true
            };
            return filterBy(data,{logic:"and",filters:[filter,siteFilter]});
        }else{
            return filterBy(data, filter);
        }
    };

    const filterChange = (event: DropDownListFilterChangeEvent|ComboBoxFilterChangeEvent) => {
        console.log(event.filter);
        event.filter.operator="startswith";
        const newData= event.filter.value.length > 2 ? filterData(event.filter).then(filteredData => setCustomers(filteredData)):[];
        return newData;
    };
    
    const defaultItem = {customer: "Customer"};

    const customerChange = (event: DropDownListChangeEvent | ComboBoxChangeEvent) => {
        if (event.value){
            console.log(event.target.value);
            if (event.target.value.fileSize2){
                setReturnAction(event.target.value);
            }else{
                if (allowNew===true){
                    var value = {customer:event.target.value.customer, fileSize2:"", file1:""}
                    setReturnAction(value);
                }                
            }
        }else{
            setReturnAction({customer:"", fileSize2:"", file1:""});
        }
    };

    const itemRender=(li: React.ReactElement<HTMLLIElement>, itemProps: ListItemProps) => {
        const acct = itemProps.dataItem["fileSize2"];
        const itemChildren = (
            <span>
                {li.props.children as any} ({acct})
            </span>
        );

        return React.cloneElement(li, li.props, itemChildren);
    };


    useEffect(()=>{
        console.log(value);
        // if (value && value.fileSize2!=""){
        //     customers.map(item=>{
        //         if (item.fileSize2==value.fileSize2){
        //             setSelCustomer(item);
        //         }
        //     });
        // }
    },[value])

    // useEffect(()=>{
    //     if (value && value.fileSize2!=""){
    //         customers.map(item=>{
    //             if (item.fileSize2==value.fileSize2){
    //                 setSelCustomer(item);
    //             }
    //         });
    //     }
    // },[customers])
    
    return (
        <>
        {allowNew?
        <ComboBox
            className='formField'
            data={customers}
            textField='customer'
            dataItemKey='fileSize2'
            itemRender={itemRender}
            filterable={true}
            onFilterChange={filterChange}
            onChange={customerChange}
            value={value}
            fillMode={"outline"}
            valid={valid}
            allowCustom={true}
            inputAttributes={{maxLength:25}}
        />
        :
        <DropDownList 
            className='formField'
            data={customers} 
            textField='customer'
            dataItemKey='fileSize2'
            itemRender={itemRender}
            defaultItem={defaultItem}
            filterable={true}
            onFilterChange={filterChange}
            onChange={customerChange}
            value={value}
            fillMode={"outline"}
            valid={valid}
        />}
        </>
    )
}

interface StatusListProps {
    setStatus: ((status: string[]) => void) | ((status:StatusDataItem)=>void);
    value:string[];
    type:string;
    enabled:boolean;
    limited:boolean;
    limitType?:string;
    className?:string;
}

export function StatusList({
    setStatus, value, type,enabled,limited,limitType,className
}: StatusListProps){
    //Component for a status drop down list

    
    const [statuses, setStatuses] = useState<StatusDataItem[]>([]);
    const [filteredStatuses, setFilteredStatuses] = useState<StatusDataItem[]>([]);

    const defaultItem = {status: "Status"};

    const statusChange = (event: MultiSelectChangeEvent) => {  
        const statString: string[] = [];
        event.target.value.forEach((value: any) => {
            console.log(value["status"]);
            statString.push(value["status"]);
        });
        console.log({statString});
        (setStatus as (status: string[]) => void)(statString);
    };

    const setNewStatus = (event: DropDownListChangeEvent)=>{
        setStatus(event.target.value);
    }

    const filterChange = (event: { filter: FilterDescriptor | CompositeFilterDescriptor; }) => {
        setFilteredStatuses(filterBy(statuses.slice(), event.filter));
    };

    const itemRender=(li: React.ReactElement<HTMLLIElement>, itemProps: ListItemProps) => {
        const statcolor = itemProps.dataItem["color"].replace(" ","_");
        const itemChildren = (           
            <span>
                 <span style={{ color: statcolor }}>
                    <FontAwesomeIcon icon={faCircle}></FontAwesomeIcon>
                 </span>&nbsp;
                {li.props.children as any}
            </span>
        );

        return React.cloneElement(li, li.props, itemChildren);
    };

    const filterStatus=()=>{

    }

    const setStatValue=()=>{
        if (value){
            const startArray:string[]=value;
            const endArray:any[]=[];
            startArray.forEach((value: any) => {
                //console.log(value);
                endArray.push({status:value});
            });
            //console.log(endArray);
            return endArray;
        }
    }

    useEffect(()=>{
        setFilteredStatuses(statuses);
    },[statuses])

    useEffect(() => {
        getStatusList().then(data => { 
            if (limited){
                let filter:FilterDescriptor={
                    field:"atolView",
                    operator: 'eq',
                    value:true
                }
                if (limitType=="autoEPS"){
                    filter={
                       field:"autoEps",
                       operator: 'eq',
                       value:true
                    }
                }
                setStatuses(filterBy(data, filter));
            }else{
                setStatuses(data);
            }
        });
    }, []);

    return type === "multi" ? (
        <MultiSelect 
            id="statusList"
            className={className?className:'formField'}
            data={filteredStatuses}
            textField='status'
            dataItemKey='status'
            placeholder='Status'
            itemRender={itemRender}
            filterable={true}
            onFilterChange={filterChange}
            onChange={statusChange}
            value={setStatValue()}
            fillMode={"outline"}
            disabled={!enabled}
        />
    ) : (
        <DropDownList
            id="statusList"
            className={className?className:'formField'}
            data={limitType=="autoEPS"?statuses.filter((item) => item.autoEps === true):statuses.filter((item) => item.atolView === true)}
            textField='status'
            dataItemKey='status'
            defaultItem={limitType?{status:"Select status"}:{status:"Set new status"}}
            fillMode={"outline"}
            value={statuses.find((item)=>item.status===value[0])}
            itemRender={itemRender}
            disabled={!enabled}
            onChange={setNewStatus}
        />
    );
}

interface RepListProps {
    setReturnAction: (rep: salesRep[]) => void;
    value:salesRep[];
    multi:boolean;
    site:SiteEntry|string;
    valid:boolean;
}

export function RepList({
    setReturnAction, value,multi,site,valid
}: RepListProps){
    //Component for a status drop down list

    const [reps, setReps] = useState<Array<salesRep>>([
        {displayName:"",
        fullName:"",
        customer:"",
        security:0,
        temp4:""
    }]);
    const [filteredReps, setFilteredReps] = useState<Array<salesRep>>([
        {displayName:"",
        fullName:"",
        customer:"",
        security:0,
        temp4:""
    }]);
    const [selRep, setSelRep]=useState<Array<salesRep>>([
        {displayName:"",
        fullName:"",
        customer:"",
        security:0,
        temp4:""
    }]);
    const userContext=useContext(UserContext);
    const subContext = useContext(SubmissionContext);

    const filterData = async (filter: FilterDescriptor|null) => {
        console.log(reps);
        console.log(filter);
        const compFilter:CompositeFilterDescriptor={logic:"and", filters:[]}
        // if ((subContext?.submitForm.site as SiteEntry).code!==""){
        //     const siteCode = (site as SiteEntry).code;
        //     const siteFilter: FilterDescriptor = {
        //         field: "temp4",
        //         value: siteCode,
        //         operator: "equals",
        //         ignoreCase:true
        //     };
        //     compFilter.filters.push(siteFilter);
        // }
        if (userContext?.user.type.toString()=="1" && !multi){
            const repId = userContext.user.customer;
            const repFilter:FilterDescriptor={
                field:"customer",
                value:repId,
                operator:"equals",
                ignoreCase:true
            }
            compFilter.filters.push(repFilter);
        }
        if (filter){
             if (!isCompositeFilterDescriptor(filter) && filter.value!==""){
                 compFilter.filters.push(filter);
             }
        }
        if (compFilter.filters.length>0){
             const filteredData=filterBy(reps,compFilter);
             setFilteredReps(filteredData);
             if (filteredData.length===1){
                setReturnAction(filteredData);
             }
        }else{
             setFilteredReps(reps);
        }
    }
    
    const filterChange = (event: MultiSelectFilterChangeEvent) => {
         if (event.filter.value!="" && event.filter.value.length>2){
            filterData(event.filter);        
         }
    };

    const filterChangeSingle = (event: DropDownListFilterChangeEvent) => {
         if (event.filter.value!="" && event.filter.value.length>2){
            filterData(event.filter);
         }
    };

    const repChange = (event: MultiSelectChangeEvent) => { 
        const repString: string[] = [];
        if (event.target.value.length>0){
            event.target.value.forEach((value: any) => {
                console.log(value["customer"]);
                repString.push(value["customer"]);
            });
            setReturnAction(event.value);    
        }else{
            setReturnAction([]);
        }
    };
    const repChangeSingle = (event: DropDownListChangeEvent) => { 
        const repString: salesRep[] = [];
        const newRep = {customer:event.value, displayName:"",security:1,temp4:"",fullName:""}
        repString.push(event.value);
        console.log(newRep);
        setReturnAction(repString);
    };

    const setRepListMulti=()=>{
        console.log(value);
        if (value){
            const startArray:{customer:string}[]=value;
            //console.log(startArray);
            const endArray:any[]=[];
            startArray.forEach((value: {customer:string}) => {
                //console.log(value);
                //console.log(sites);
                reps.forEach((rep)=>{
                    if (rep.customer==value.customer){
                        endArray.push(rep);
                    }
                });
            });
            console.log(endArray);
            //setSelRep(endArray);
            //setReturnAction(endArray);
            return(endArray);
        }
    } 

    const setRepValueSingle=()=>{
        return value[0];
    }

    useEffect(()=>{
        getRepList().then(data => {
             setReps(data); 
        });
    },[]);

    useEffect(()=>{
        filterData(null);        
    },[reps]);

    useEffect(()=>{
        //setReturnAction(selRep);
    },[selRep])

    if (multi){
        return (
            <MultiSelect 
                id="repList"
                className='formField'
                data={filteredReps}
                textField='displayName'
                dataItemKey='customer'
                placeholder='Salesperson'
                filterable={true}
                onFilterChange={filterChange}
                onChange={repChange}
                value={setRepListMulti()}
                fillMode={"outline"}
            />
        );
    }else{
        return (
            <DropDownList 
                id="repList"
                className='formField'
                data={filteredReps}
                textField='displayName'
                dataItemKey='customer'
                //placeholder='Salesperson'
                filterable={true}
                onFilterChange={filterChangeSingle}
                onChange={repChangeSingle}
                value={setRepValueSingle()}
                fillMode={"outline"}
                valid={valid}
            />
        );
    }

}

interface SectionListProps {
    setSearchSection: (status: string[]) => void;
    value:string[];
}

export function SectionList({
    setSearchSection, value
}: SectionListProps){
    //Component for a status drop down list

    
    const [sections, setSections] = useState<any[]>([]);
    
    const filterData = async (filter: FilterDescriptor | CompositeFilterDescriptor) => {
        const data = await getStatusList();
        return filterBy(data, filter);
    };

    const filterChange = (event: MultiSelectFilterChangeEvent) => {
        filterData(event.filter).then(filteredData => setSections(filteredData));
    };

    const defaultItem = {status: "Status"};

    //const sectionChange = (event: MultiSelectChangeEvent) => {
    //    setSearchSection(JSON.stringify(event.target.value));
    //};
    const sectionChange = (event: MultiSelectChangeEvent) => {  
        const sectString: string[] = [];
        event.target.value.forEach((value: any) => {
            console.log(value["section"]);
            sectString.push(value["section"]);
        });
        console.log({sectString});
        setSearchSection(sectString);
    };

    const setSectionValue=()=>{
        if (value){
            const startArray:string[]=value;
            const endArray:any[]=[];
            startArray.forEach((value: any) => {
                console.log(value);
                endArray.push({section:value});
            });
            return endArray;
        }
    }
    
    useEffect(() => {
        getSectionList().then(data => {
            setSections(data);
        });
    }, []);

    return (
        <MultiSelect 
            id="sectList"
            className='formField'
            data={sections}
            textField='section'
            dataItemKey='section'
            placeholder='Section'
            filterable={true}
            onFilterChange={filterChange}
            onChange={sectionChange}
            value={setSectionValue()}
            fillMode={"outline"}
        />
    );
}

interface TeamListProps {
    setSearchTeam: (team: string[]) => void;
    value:string[];
}

export function TeamList({
    setSearchTeam, value
}: TeamListProps){
    //Component for a status drop down list

    
    const [teams, setTeams] = useState<any[]>([]);
    
    const filterData = async (filter: FilterDescriptor | CompositeFilterDescriptor) => {
        const data = await getStatusList();
        return filterBy(data, filter);
    };

    const filterChange = (event: MultiSelectFilterChangeEvent) => {
        filterData(event.filter).then(filteredData => setTeams(filteredData));
    };

    const defaultItem = {status: "Status"};

    
    const teamChange = (event: MultiSelectChangeEvent) => {  
        const teamString: string[] = [];
        event.target.value.forEach((value: any) => {
            console.log(value["team"]);
            teamString.push(value["team"]);
        });
        console.log({teamString});
        setSearchTeam(teamString);
    };
    const setTeamValue=()=>{
        if (value){
            const startArray:string[]=value;
            const endArray:any[]=[];
            startArray.forEach((value: any) => {
                console.log(value);
                endArray.push({team:value});
            });
            return endArray;
        }
    }
    useEffect(() => {
        getTeamList().then(data => {
            setTeams(data);
        });
    }, []);

    return (
        <MultiSelect 
            id="teamList"
            className='formField'
            data={teams}
            textField='team'
            dataItemKey='team'
            placeholder='Team'
            filterable={true}
            onFilterChange={filterChange}
            onChange={teamChange}
            value={setTeamValue()}
            fillMode={"outline"}
        />
    );
}

interface SizeListProps {
    setSearchSize: (size: any) => void;
    value:string;
}

export function SizeList({
    setSearchSize,value
}: SizeListProps){
    //Component for a customer drop down list
    const [sizes, setSizes] = useState<any[]>([]);
    const [selSize, setSelSize]= useState<{size:string}|undefined>();
    const filterData = async (filter: FilterDescriptor | CompositeFilterDescriptor) => {
        const data = await getSizeList();
        return filterBy(data, filter);
    };

    const filterChange = (event: DropDownListFilterChangeEvent) => {
        if (event.filter.value.length > 2){
            filterData(event.filter).then(filteredData => setSizes(filteredData))
        }
    };
    
    const defaultItem = {size: "Size"};

    const sizeChange = (event: DropDownListChangeEvent) => {
        console.log(event.target.value);
        setSearchSize(event.target.value["size"]);
    };


    useEffect(()=>{
        console.log(value);
        if (value && value!=""){
            setSelSize({size:value});
        }else{
            setSelSize(undefined);
        }
    },[value])
    

    function setCustValue(){
        if (value ===""){
            return null
        }else{
            return {customer: value};
        }
    }
    return (
        <DropDownList 
            className='formField'
            data={sizes} 
            textField='size'
            dataItemKey='size'
            defaultItem={defaultItem}
            filterable={true}
            onFilterChange={filterChange}
            onChange={sizeChange}
            value={selSize}
            fillMode={"outline"}
        />
    )
}

interface ColTypeListProps {
    setReturnAction: (colType: ColTypeEntry[]) => void;
    value:ColTypeEntry[];
    multi:boolean;
    valid:boolean;
    site:SiteEntry;
    adType:string;
    className:string;
}

export function ColTypeList({
    setReturnAction, value,multi,valid,site,adType,className
}: ColTypeListProps){
    //Component for a status drop down list

    const [colTypes, setColTypes] = useState<any[]>([]);
    
    const filterData = async (filter: FilterDescriptor | CompositeFilterDescriptor|undefined) => {
        //const data = await getColTypeList();
        getColTypeList().then(data => {
            const compFilter:CompositeFilterDescriptor={logic:"and", filters:[]}
            if(filter){
                compFilter.filters.push(filter);
            }
            if (!multi){
                if (site.code !== ""){
                    const siteFilter:FilterDescriptor = {field:"site",value:site.code,operator:"equals"};
                    compFilter.filters.push(siteFilter);
                }    
            }
            const filteredData= filterBy(data, compFilter);
            const uniqueData = filteredData.filter((value,index,self)=>
                        index===self.findIndex((t)=>(
                            (t as ColTypeEntry).category===(value as ColTypeEntry).category && (t as ColTypeEntry).type===(value as ColTypeEntry).type
                        ))  
                    )
            setColTypes(uniqueData);
        });
    };

    const filterChange = (event: MultiSelectFilterChangeEvent|DropDownListFilterChangeEvent) => {
        if (event.filter.value.length>=3){
            filterData(event.filter);
        }
    };

    const defaultItem = {category: "Type"};

    
    const colTypeChange = (event: MultiSelectChangeEvent) => {  
        const colTypeString: ColTypeEntry[] = [];
        event.target.value.forEach((value: any) => {
            console.log(value["category"]);
            colTypeString.push(value["category"]);
        });
        console.log({colTypeString});
        setReturnAction(colTypeString);
    };

    const colTypeChangeSingle = (event: DropDownListChangeEvent) => {  
        const colTypeString: ColTypeEntry[] = [];
        //event.target.value.forEach((value: any) => {
        //    console.log(value["category"]);
        //    colTypeString.push(value["category"]);
        //})
        colTypeString.push(event.value);
        console.log({colTypeString});
        setReturnAction(colTypeString);
    };
    const setCategoryValue=()=>{
        if (value){
            const startArray:ColTypeEntry[]=value;
            const endArray:any[]=[];
            startArray.forEach((value: any) => {
                console.log(value);
                endArray.push({category:value});
            });
            return endArray;
        }
    }

    const itemRender=(li: React.ReactElement<HTMLLIElement>, itemProps: ListItemProps) => {
        const retVal = itemProps.dataItem.type=="M"?itemProps.dataItem.category + " (Modular)":itemProps.dataItem.category;
        return React.cloneElement(li, li.props, retVal);
    };


    useEffect(() => {
        console.log(value);
        if (adType=="RM"){
            const olFilter: CompositeFilterDescriptor = {
                logic: "and",
                filters: [
                    { field: "category", value: "ONLINE", operator: "equals" },
                    { field: "type", value: "M", operator: "equals" }
                ]
            };
            filterData(olFilter);
        }else if (adType=="DA")
            {
            const olFilter:FilterDescriptor = {field:"category",value: "ONLINE", operator:"neq"};
            filterData(olFilter);
        }else if (adType=="M"){
            const olFilter:FilterDescriptor = {field:"type",value: "M", operator:"equals"};
            filterData(olFilter);    
        }else{
            filterData(undefined);        
        }
    }, [site]);
    if (multi){
        return (
            <MultiSelect 
                id="colTypeList"
                className={className}
                data={colTypes}
                textField='category'
                //dataItemKey='category'
                placeholder='Type'
                filterable={true}
                onFilterChange={filterChange}
                onChange={colTypeChange}
                value={setCategoryValue()}
                fillMode={"outline"}
                valid={valid}
            />
        );
    }else{
        return(
            <DropDownList
                id="colTypeList"
                className={className}
                fillMode={"outline"}
                data={colTypes}
                textField='category'
                //dataItemKey='category'
                filterable={true}
                onFilterChange={filterChange}
                onChange={colTypeChangeSingle}
                value={value[0]}
                itemRender={itemRender} 
                valid={valid}
            />
        );
    }
}

interface ModColTypeListProps {
    setReturnAction: (colType: ColTypeEntry[]) => void;
    value:ColTypeEntry[]|string;
    valid:boolean;
    site:SiteEntry;
    className:string;
}

export function ModColTypeList({
    setReturnAction, value,valid,site,className
}: ModColTypeListProps){
    //Component for a status drop down list

    const [colTypes, setColTypes] = useState<ColTypeEntry[]>([]);
    const [selCat, setSelCat]=useState<ColTypeEntry>();
    const filterData = async (filter: FilterDescriptor | CompositeFilterDescriptor|undefined) => {
        //const data = await getColTypeList();
        console.log("GetModColTypes " + site.code);
        getModColTypes(site.code).then(data => {
            const compFilter:CompositeFilterDescriptor={logic:"and", filters:[]}
            if(filter){
                compFilter.filters.push(filter);
            }
            const filteredData= filterBy(data, compFilter);
            const uniqueData = filteredData.filter((value,index,self)=>
                        index===self.findIndex((t)=>(
                            (t as ColTypeEntry).category===(value as ColTypeEntry).category && (t as ColTypeEntry).type===(value as ColTypeEntry).type
                        ))  
                    )
            console.log(uniqueData);
            setColTypes(uniqueData as ColTypeEntry[]);
        });
    };

    const filterChange = (event: MultiSelectFilterChangeEvent|DropDownListFilterChangeEvent) => {
        if (event.filter.value.length>=3){
            filterData(event.filter);
        }
    };

    const defaultItem = {category: "Type"};

    
    const colTypeChange = (event: MultiSelectChangeEvent) => {  
        const colTypeString: ColTypeEntry[] = [];
        event.target.value.forEach((value: any) => {
            console.log(value["category"]);
            colTypeString.push(value["category"]);
        });
        console.log({colTypeString});
        setReturnAction(colTypeString);
    };

    const colTypeChangeSingle = (event: DropDownListChangeEvent) => {  
        const colTypeString: ColTypeEntry[] = [];
        //event.target.value.forEach((value: any) => {
        //    console.log(value["category"]);
        //    colTypeString.push(value["category"]);
        //})
        colTypeString.push(event.value);
        console.log({colTypeString});
        setReturnAction(colTypeString);
    };
    const setCategoryValue=()=>{
        if (typeof value=="string"){
            const finVal = colTypes.find((item) => item.category === value);
            return finVal ? [finVal] : [];
        }else{
            if (value){
                const startArray:ColTypeEntry[]=value;
                const endArray:any[]=[];
                startArray.forEach((value: any) => {
                    console.log(value);
                    endArray.push({category:value});
                });
                return endArray;
            }
        }
    }

    const itemRender=(li: React.ReactElement<HTMLLIElement>, itemProps: ListItemProps) => {
        const retVal = itemProps.dataItem.type=="M"?itemProps.dataItem.category + " (Modular)":itemProps.dataItem.category;
        return React.cloneElement(li, li.props, retVal);
    };

    useEffect(()=>{
        if (value){
            colTypes.forEach(col=>{
                if (col.category==value){
                    setSelCat(col);
                }
            })
        }
    },[colTypes])


    useEffect(() => {
        console.log(site);
        console.log(value);
        if (site.code!==""){
            filterData(undefined);        
        }
    }, [site]);
    return(
        <DropDownList
            id="ModColTypeList"
            className={className}
            fillMode={"outline"}
            data={colTypes}
            textField='category'
            dataItemKey='category'
            filterable={true}
            onFilterChange={filterChange}
            onChange={colTypeChangeSingle}
            value={selCat}
            //itemRender={itemRender} 
            valid={valid}
        />
    );
}


interface SiteListProps {
    setReturnAction: (site: SiteEntry[]) => void;
    value:SiteEntry[]|SiteEntry|String;
    multi:boolean;
    valid:boolean;
    className:string;
}
export function SiteList({
    setReturnAction, value,multi,valid,className
}: SiteListProps){

    
    const [sites, setSites] = useState<any[]>([]);
    const [selSite,setSelSite]=useState<SiteEntry>();
    const [selSites, setSelSites]=useState<SiteEntry[]>([]);
    const userContext=useContext(UserContext);
    const filterData = async (filter: FilterDescriptor | CompositeFilterDescriptor) => {
        const data = await getSiteList();
        const val = isCompositeFilterDescriptor(filter) ? '' : filter.value;
        const codeFilter:FilterDescriptor={
            field:"code",
            ignoreCase:true,
            operator:"contains",
            value:val
        }
        const compFilter:CompositeFilterDescriptor={
            logic:"or",
            filters:[filter,codeFilter]
        }
        return filterBy(data, compFilter);
    };

    const filterChange = (event: MultiSelectFilterChangeEvent) => {
        filterData(event.filter).then(filteredData => setSites(filteredData));
    };

    const filterChangeSingle = (event: DropDownListFilterChangeEvent) => {
        filterData(event.filter).then(filteredData => setSites(filteredData));
    };
    
    const siteChange = (event: MultiSelectChangeEvent) => {  
        const siteString: SiteEntry[] = [];
        event.target.value.forEach((value: any) => {
            console.log(value["code"]);
            siteString.push(value["code"]);
        });
        console.log({siteString});
        setReturnAction(siteString);
    };

    const siteSingleChange = (event: DropDownListChangeEvent) => {  
        const siteString: SiteEntry[] = [];
        siteString.push(event.value);
        console.log({siteString});
        setReturnAction(siteString);
    };

    const setSiteSingleValue = ()=>{
        console.log(value);
        if (value){
            if (!Array.isArray(value)){
                //not an array
                if (typeof value =="string" && value!==""){
                //single non blank string value
                    sites.forEach((site)=>{
                        if (site.code === value ){
                            setSelSite(site);
                        }
                    })
                }else{
                    sites.forEach((site)=>{
                        if (site.code===(value as SiteEntry).code){
                            setSelSite(site);
                        }
                    })
                }
            }
        }else{
            console.log("No site value provided. Checking user site");
            console.log(sites.length);
            console.log(sites);
            console.log(userContext?.user.siteCode);
            if (sites.length==2){
                setSelSite(sites[1]);
                const siteString: SiteEntry[] = [];
                siteString.push(sites[1]);
                setReturnAction(siteString);                
            }
        }
    }

    const setSiteValue=()=>{
        
        console.log(value);
        if (value){
            if (Array.isArray(value)){
                const startArray:SiteEntry[]=value;
                //console.log(startArray);
                const endArray:any[]=[];
                startArray.forEach((value: any) => {
                    //console.log(value);
                    //console.log(sites);
                    sites.forEach((site)=>{
                        if (site.code !=null &&(site.code==value.code||site.code==value)){
                            endArray.push(site);
                        }
                    });
                });
                console.log(endArray);
                setSelSites (endArray);    
            }else{
                return Array.isArray(value) ? value : [value];
            }
        }else{
            return (undefined);
        }
    }
    const itemRender = (li: React.ReactElement<HTMLLIElement>, itemProps: ListItemProps) => {
        const itemChildren = (
            <span>
                {itemProps.dataItem.name} ({itemProps.dataItem.code})
            </span>
        );

        return React.cloneElement(li, li.props, itemChildren);
    };

    useEffect(()=>{
        if(multi){
            //if (selSites.length<1){
                setSiteValue();
            //}
        }else{
            setSiteSingleValue();
        }
    },[sites])

    useEffect(()=>{
        if(multi){
            //if (selSites.length<1){
                setSiteValue();
            //}
        }else{
            setSiteSingleValue();
        }
    },[value])

    useEffect(()=>{
        if (selSite){
            setReturnAction([selSite]);                
        }
    },[selSite])

    useEffect(() => {
        getSiteList().then(data => {
            console.log(data);
            data.unshift({code:null, name:"Select site",logo_prefix:"",primary_ip:"",backup_ip:"",temp_Char:"",temp_Int:0,vol1_Unc_Path:"",vol2_Unc_Path:""});
            setSites(data);
        });
    }, []);

    if (multi){
        return (
            <MultiSelect 
            id="siteList"
            className={className}
            data={sites}
            textField='name'
            dataItemKey='code'
            placeholder='Site'
            filterable={true}
            onFilterChange={filterChange}
            onChange={siteChange}
            value={selSites}
            fillMode={"outline"}
        />       
    );
    }else{
        return (
            <DropDownList 
            id="siteList"
            className={className}
            data={sites}
            textField='name'
            dataItemKey='code'
            defaultValue={{code:null, name:"Select site",logo_prefix:"",primary_ip:"",backup_ip:"",temp_Char:"",temp_Int:0,vol1_Unc_Path:"",vol2_Unc_Path:""}}
            filterable={true}
            onFilterChange={filterChangeSingle}
            onChange={siteSingleChange}
            value={selSite}
            fillMode={"outline"}
            valid={valid}
            itemRender={itemRender}
        />       
    );
    }
}

interface PubListProps {
    setReturnAction: (pub: string[]) => void;
    value:string[];
    type:string;
    archiveOnly:boolean;
    liveOnly:boolean;
    siteFilter:string;
    className:string;
    returnField:string;
    onlineOnly:boolean;
    printOnly:boolean;
    same:boolean
}
export function PubList({
    setReturnAction, value, type,archiveOnly,liveOnly,siteFilter,className,returnField, printOnly,onlineOnly,same
}: PubListProps){
    //Component for a status drop down list

    
    const [pubs, setPubs] = useState<any[]>([]);
    const [selPub, setSelPub]= useState<PubListEntry>();
    const [selPubs, setSelPubs] = useState<PubListEntry[]>([]);
    const filterData = async (filter: FilterDescriptor | CompositeFilterDescriptor) => {
        const data = await getPubList();
        const compFilter:CompositeFilterDescriptor={logic:"and", filters:[]}
        if (archiveOnly==true){
            const newFilter:FilterDescriptor = {field:"isArchivePub", operator:"eq", value:"1"}
            compFilter.filters.push(newFilter);
        }else if (liveOnly==true){
            const newFilter:FilterDescriptor = {field:"isActivePub", operator:"eq", value:"1"}
            compFilter.filters.push(newFilter);
        }
        if (siteFilter!=""){
            const newFilter:FilterDescriptor = {field:"tmpChar", operator:"eq", value:siteFilter}
            compFilter.filters.push(newFilter);
        }
        if (printOnly==true){
            const newFilter:FilterDescriptor = {field:"tmp_char2", operator:"eq", value:"PRINT"}
            compFilter.filters.push(newFilter);
        }
        if (onlineOnly==true){
            const newFilter:FilterDescriptor = {field:"tmp_char2", operator:"eq", value:"ONLINE"}
            compFilter.filters.push(newFilter);
        }               
        compFilter.filters.push(filter);
        const filtData =filterBy(data, compFilter);
        if (same){
            //add SAME PUB to the list as pub -1
            const SamePub:PubListEntry={
                pubName:"SAME",
                pubNum:-1,
                tmpChar:"",
                tmpChar2:"",
                isActivePub:1,
                isArchivePub:0,
                killDelay:0,
                killPath:"",
                opiPath:"",
                opiPathA:"",
                purgeDelay:0,
                tmpInt1:0,
                tmpInt2:0,
                autoToning:"",
                archiveName:""
            }
            filtData.unshift(SamePub);
        }
        return filtData;
    };

    const filterChange = (event: MultiSelectFilterChangeEvent) => {
        filterData(event.filter).then(filteredData => setPubs(filteredData));
    };

     const singleFilterChange = (event: DropDownListFilterChangeEvent) => {
        filterData(event.filter).then(filteredData => setPubs(filteredData));
    };
    
    const pubChange = (event: MultiSelectChangeEvent) => {  
        const pubString: string[] = [];
        event.target.value.forEach((value: any) => {
            //console.log(value["pubNum"]);
            if (returnField=="name"){
                pubString.push(value["pubName"]);

            }else{
                pubString.push(value["pubNum"]);
            }
        });
        console.log({pubString});
        setReturnAction(pubString);
    };

    const setNewPub = (event: DropDownListChangeEvent)=>{
        const pubString: string[] = [];
        if (returnField=="name"){
            pubString.push(event.target.value["pubName"]);

        }else{
            pubString.push(event.target.value["pubNum"]);
        }
        console.log(pubString);
        setReturnAction(pubString);
    }
    const setPubValue=()=>{
        //console.log(value);
        if (value){
            const startArray:string[]=value;
            //console.log(startArray);
            const endArray:any[]=[];
            startArray.forEach((value: any) => {
                //console.log(value);
                //console.log(sites);
                pubs.forEach((pub)=>{
                    if(returnField=="name"){
                        if (pub.pubName==value){
                            endArray.push(pub);
                        }
                    }else{
                        if (pub.pubNum==value){
                            endArray.push(pub);
                        }
                    }
                });
            });
            //console.log(endArray);
            setSelPubs(endArray);
            //return (endArray);
        }else{
            //return (undefined);
        }
    }

    const setSinglePubValue=()=>{
        if (value && value.length>0){
            console.log(pubs);
            pubs.forEach((pub)=>{
                if (pub.pubNum==value || pub.pubName==value){
                    setSelPub(pub);
                }
            });
        }
    }

    const getFilteredPubList=()=>{
        getPubList().then(data => {
            console.log(data);
             const compFilter:CompositeFilterDescriptor={logic:"and", filters:[]}
            if (archiveOnly==true){
                const newFilter:FilterDescriptor = {field:"isArchivePub", operator:"eq", value:"1"}
                compFilter.filters.push(newFilter);
            }else if (liveOnly==true){
                const newFilter:FilterDescriptor = {field:"isActivePub", operator:"eq", value:"1"}
                compFilter.filters.push(newFilter);
            }
            if (siteFilter!=""){
                const newFilter:FilterDescriptor = {field:"tmpChar", operator:"eq", value:siteFilter}
                compFilter.filters.push(newFilter);
            }       
            if (compFilter.filters.length>0){
                const filtPubs = filterBy(data, compFilter)
                if (same){
                    //add SAME PUB to the list as pub -1
                    const SamePub:PubListEntry={
                        pubName:"SAME",
                        pubNum:-1,
                        tmpChar:"",
                        tmpChar2:"",
                        isActivePub:1,
                        isArchivePub:0,
                        killDelay:0,
                        killPath:"",
                        opiPath:"",
                        opiPathA:"",
                        purgeDelay:0,
                        tmpInt1:0,
                        tmpInt2:0,
                        autoToning:"",
                        archiveName:""
                    }
                    filtPubs.unshift(SamePub);
                }
                setPubs(filtPubs);
            }else{
                const filtPubs = data;
                if (same){
                    //add SAME PUB to the list as pub -1
                    const SamePub:PubListEntry={
                        pubName:"SAME",
                        pubNum:-1,
                        tmpChar:"",
                        tmpChar2:"",
                        isActivePub:1,
                        isArchivePub:0,
                        killDelay:0,
                        killPath:"",
                        opiPath:"",
                        opiPathA:"",
                        purgeDelay:0,
                        tmpInt1:0,
                        tmpInt2:0,
                        autoToning:"",
                        archiveName:""
                    }
                }
                setPubs(filtPubs);
            }

        });
    }

    useEffect(()=>{
        console.log(value);
         if (type=="multi"){
            setPubValue();
        }else{
            setSinglePubValue();
        }
    },[value])

    useEffect(()=>{
        //const newFilter:FilterDescriptor = {field:"tmpChar", operator:"eq", value:{siteFilter}}
        console.log(siteFilter);
        //filterData(newFilter).then(filteredData => setPubs(filteredData));
        getFilteredPubList();

    },[siteFilter])

    useEffect(()=>{
        if (type=="multi"){
            setPubValue();
        }else{
            setSinglePubValue();
        }
    },[pubs]);

    useEffect(() => {
        getFilteredPubList();
        // getPubList().then(data => {
        //      const compFilter:CompositeFilterDescriptor={logic:"and", filters:[]}
        //     if (archiveOnly==true){
        //         const newFilter:FilterDescriptor = {field:"isArchivePub", operator:"eq", value:"1"}
        //         compFilter.filters.push(newFilter);
        //     }else if (liveOnly==true){
        //         const newFilter:FilterDescriptor = {field:"isActiveAd", operator:"eq", value:"1"}
        //     }
        //     if (compFilter.filters.length>0){
        //         const filtPubs = filterBy(data, compFilter)
        //         setPubs(filtPubs);
        //     }else{
        //         setPubs(data);
        //     }
        // });
    }, []);

    return type==="multi"?(
        <MultiSelect 
            id="pubList"
            className={className}
            data={pubs}
            textField='pubName'
            dataItemKey='pubNum'
            placeholder='Publication'
            filterable={true}
            onFilterChange={filterChange}
            onChange={pubChange}
            value={selPubs}
            fillMode={"outline"}
        />
        ) : (
        <DropDownList
            id="pubList"
            data={pubs}
            className={className}
            textField='pubName'
            dataItemKey='pubNum'
            filterable={true}
            defaultItem={{pubName: "Select a publication...",pubNum: 9999999999}}            
            onFilterChange={singleFilterChange}
            onChange={setNewPub}
            value={selPub}
            fillMode={"outline"}
        />
        );
}

interface SavedQuery{
    query_Num:number,
    query_Name:string,
    sqL_Query_1000:string,
    query_Owner:string
}

interface SavedQueryListProps {
    setSavedQuery: (query: SavedQuery) => void;
    value:SavedQuery;
}

export function SavedQueryList({
    setSavedQuery, value
}: SavedQueryListProps){

    const [queries, setQueries] = useState<any[]>([]);
    const defaultItem = {query_Name: "Saved Queries"};
    const queryChange = (event: DropDownListChangeEvent) => {
        setSavedQuery(event.target.value);
    };
    useEffect(() => {
        getSavedQueries().then(data => {
            setQueries(data);
        });
    }, []);

    return (
        <DropDownList 
            id="queryList"
            data={queries}
            className='formField'
            textField='query_Name'
            defaultItem={defaultItem}
            onChange={queryChange}
            fillMode={"outline"}
        />
    );

}

interface PickupListProps {
    setPickup: ({}: PickupSelection) => void;
    value:{};
    sameCust:boolean;
    //account:string;
    //ad:string;
    //adType:string;
    //category:string;    
    //value:string;
}

export function PickupList({
    setPickup, value,sameCust
    //setPickup,account, ad, adType, category, value
}: PickupListProps){
    //Component for a customer drop down list
    const [ads, setAds] = useState<any[]>([]);
    const [thisCust, setThisCust] = useState(true);
    const pageContext=useContext(PageContext);
    const subContext= useContext(SubmissionContext);

    const [selectedAds, setSelectedAds] = useState([]);

    var account="";
    var category = "";
    var adType ="";
    switch (subContext?.submitForm.subType){
        case "SB":
        case "CR":
            account = pageContext?.selectedAd.fileSize2 ?? "";
            adType = pageContext?.selectedAd.elementType ??"";
            category=pageContext?.selectedAd.category??"";       
            break;
        case "OS":
        case "SP":
        case "NO":
            account = subContext?.submitForm.account; 
            adType = subContext?.submitForm.adType.value;
            category = subContext?.submitForm.category.category;
            break;
    }
    //account = thisCust?subContext.submitForm.subType==="SB"||subContext.submitForm.subType==="CR"?pageContext?.selectedAd.fileSize2?pageContext?.selectedAd.fileSize2:subContext?.submitForm.account:"":"";
    //adType = pageContext?.selectedAd.elementType?pageContext?.selectedAd.elementType:subContext?.submitForm.adType.value;
    //category =pageContext?.selectedAd.category?pageContext?.selectedAd.category:subContext?.submitForm.category.category;
    const [allCust,setAllCust]=useState(false);

    const allowAllCustomer=()=>{
        if (sameCust){ 
            return false;
        }else{
            return pageContext?.glSettings.AllowPickupFromAllCustomers;
        }
    }
    const filterData = async (filter: FilterDescriptor | CompositeFilterDescriptor) => {
        const data = await getPickupList(account,adType,"",category);
        const compFilter :CompositeFilterDescriptor={logic:"and",filters:[filter,{field:"element", operator:"neq",value:pageContext?.selectedAd.element}]}
        console.log(data);
        return filterBy(data, compFilter);
    };

    const filterChange = (event: DropDownListFilterChangeEvent) => {

        if (thisCust){
            const newData= event.filter.value.length > 2 ? filterData(event.filter).then(filteredData => setAds(filteredData)):[];
            console.log(newData);

            return newData;    
        }else{
            if (event.filter.value.length>4){
                const ad = event.filter.value;
                if (allCust === true){
                   account="";
                }
                getPickupList(account,adType,ad,category).then(data => {
                    if (data!=null){
                        console.log(data);
                        setAds(data);
                    }else{
                        setAds([]);
                    }
                });
            }
        }
    };

    const defaultItem = {size: "Size"};

    const pickupChange = (event: DropDownListChangeEvent) => {
        console.log(event.target.value);
        setPickup(event.target.value);
        //setPickup(event.target.value["element"]);
    };

    const custChange=(check:CheckboxChangeEvent)=>{
        setThisCust(!!check.target.value)
    }

    const itemRender=(li: React.ReactElement<HTMLLIElement>, itemProps: ListItemProps) => {
        const acct:string = itemProps.dataItem["fileSize2"];
        const fr:string = itemProps.dataItem["firstRun"];
        const tag:string = itemProps.dataItem["comment2"];
        const type:string = itemProps.dataItem["elementType"];
        //const ldate:string = makeShortDate(fr);
        const slug:string = itemProps.dataItem["slug"];
        const size:string = itemProps.dataItem["size"];
        const cat:string = itemProps.dataItem["category"];
        const cust:string  = itemProps.dataItem["customer"];
        const thmbPath:string = itemProps.dataItem["thumbPath"];

        

        const itemChildren = (
            itemProps.dataItem.thumbPath?
            <span>
                <img src={thmbPath} height={"100px"} width={"100px"}/> {li.props.children as any} ({size} {cust} {fr} {cat})<br/>{tag}
            </span>
            :
            <span>
                {li.props.children as any} ({size} {cust} {fr} {cat} {thmbPath})<br/>{tag}     
            </span>
        );

        return React.cloneElement(li, li.props, itemChildren);
    };

    const enableAllCustomers=()=>{
        //console.log(allowAllCustomer);
        if (allowAllCustomer()==true){
            //console.log("All customers Enabled");
            setAllCust(false);
        }else{
            //console.log("All customers Disabled");
            setAllCust(true);
        }
    }

    useEffect(() => {
        enableAllCustomers();
        if (allCust === true){
            account="";
        }
        getPickupList(account,adType,"",category).then(data => {
            const filter:FilterDescriptor={field:"element",operator:"neq",value:pageContext?.selectedAd.element}
            if (data!=null){
                const fillData = filterBy(data,filter);
                console.log(fillData);
                setAds(fillData);
            }else{
                setAds([]);
            }
        });
    }, [thisCust]);

    return (
        <>
        {sameCust==false?<Checkbox className="mb-2" label='Only show ads for this customer' checked={thisCust} onChange={custChange} disabled={!allCust}/>:null} 
        <DropDownList 
            className='formField'
            data={ads} 
            textField='element'
            dataItemKey='element'
            defaultItem={defaultItem}
            filterable={true}
            onFilterChange={filterChange}
            onChange={pickupChange}
            itemRender={itemRender}
            value={value}
            fillMode={"outline"}
        />
        </>
    )
}

interface PickupToListProps {
    setPickup: (pickupSelections: PickupSelection[]) => void;
    value:PickupSelection[];
    sameCust:boolean;
    //account:string;
    //ad:string;
    //adType:string;
    //category:string;    
    //value:string;
}
export function PickupToList({
    setPickup, value,sameCust
    //setPickup,account, ad, adType, category, value
}: PickupToListProps){
    //Component for a customer drop down list
    const [ads, setAds] = useState<any[]>([]);
    const [thisCust, setThisCust] = useState(true);
    const pageContext=useContext(PageContext);
    const subContext= useContext(SubmissionContext);

    const [selectedAds, setSelectedAds] = useState([]);

    const account = thisCust?pageContext?.selectedAd.fileSize2?pageContext?.selectedAd.fileSize2:subContext?.submitForm.account:"";
    const adType = pageContext?.selectedAd.elementType?pageContext?.selectedAd.elementType:subContext?.submitForm.adType.value;

    const filterData = async (filter: FilterDescriptor | CompositeFilterDescriptor) => {
        const data = await getPickupToList(account,adType);
        const compFilter :CompositeFilterDescriptor={logic:"and",filters:[filter,{field:"element", operator:"neq",value:pageContext?.selectedAd.element}]}
        console.log(data);
        return filterBy(data, compFilter);
    };

    const filterChange = (event: MultiSelectFilterChangeEvent) => {        if (thisCust){
            const newData= event.filter.value.length > 2 ? filterData(event.filter).then(filteredData => setAds(filteredData)):[];
            return newData;    
        }else{
            if (event.filter.value.length>4){
                const ad = event.filter.value;
                getPickupToList(account,adType).then(data => {
                    if (data!=null){
                        setAds(data);
                    }else{
                        setAds([]);
                    }
                });
            }
        }
    };

    const defaultItem = {size: "Size"};

    const pickupChange = (event: MultiSelectChangeEvent) => {
        //console.log(event.target.value);
        setPickup(event.target.value);
        //setPickup(event.target.value["element"]);
    };

    const custChange=(check:CheckboxChangeEvent)=>{
        setThisCust(!!check.target.value)
    }

    const itemRender=(li: React.ReactElement<HTMLLIElement>, itemProps: ListItemProps) => {
        const acct:string = itemProps.dataItem["fileSize2"];
        const fr:string = itemProps.dataItem["firstRun"];
        //const ldate:string = makeShortDate(fr);
        const slug:string = itemProps.dataItem["slug"];
        const size:string = itemProps.dataItem["size"];
        const cat:string = itemProps.dataItem["category"];
        const cust:string  = itemProps.dataItem["customer"];
        const thmbPath:string = itemProps.dataItem["thumbPath"];

        

        const itemChildren = (
            itemProps.dataItem.thumbPath?
            <span>
                <img src={thmbPath} height={"100px"} width={"100px"}/> {li.props.children as any} ({size} {cust} {fr})
            </span>
            :
            <span>
                {li.props.children as any} ({size} {cust} {fr} {thmbPath})     
            </span>
        );

        return React.cloneElement(li, li.props, itemChildren);
    };


    useEffect(() => {
        console.log(value);
        getPickupToList(account,adType).then(data => {
            const filter:FilterDescriptor={field:"element",operator:"neq",value:pageContext?.selectedAd.element}
            if (data!=null){
                const fillData = filterBy(data,filter);
                setAds(fillData);
            }else{
                setAds([]);
            }
        });
    }, []);

    return (
        <>
        <MultiSelect 
            className='formField'
            data={ads} 
            textField='element'
            dataItemKey='element'
            filterable={true}
            onFilterChange={filterChange}
            onChange={pickupChange}
            itemRender={itemRender}
            value={value}
            fillMode={"outline"}
        />
        </>
    )
}





interface RollUpGroupListProps {
    setValue: (group:rollUpGroup) => void;
    value:rollUpGroup;
    valid:boolean;
}

export function RollUpGroupList({
    setValue, value,valid
}: RollUpGroupListProps){

    const [groups, setGroups] = useState<any[]>([]);
    const defaultItem = {groupName: "Select Group"};
    const groupChange = (event: DropDownListChangeEvent) => {
        setValue(event.target.value);
    };
    useEffect(() => {
        getAllRollUpGroups().then(data => {
            data.unshift({groupId:"",groupName:"Select group"});
            setGroups(data);
        });
    }, []);

    return (
        <DropDownList 
            id="rollupGroupList"
            data={groups}
            className='formField'
            textField='groupName'
            defaultItem={defaultItem}
            onChange={groupChange}
            fillMode={"outline"}
            valid={valid}
            value={value}
        />
    );

}

